module.exports = __webpack_public_path__ + "img/LOGO-white-min.48cc8096.svg";